import { render, staticRenderFns } from "./MainFilters.vue?vue&type=template&id=22b8f376&scoped=true"
import script from "./MainFilters.vue?vue&type=script&lang=js"
export * from "./MainFilters.vue?vue&type=script&lang=js"
import style0 from "./MainFilters.vue?vue&type=style&index=0&id=22b8f376&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b8f376",
  null
  
)

export default component.exports